import { Code2, Smartphone, Cloud, BrainCircuit, PenTool, ShieldCheck } from "lucide-react";

export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_014d8a17-6ce0-44ff-9bcf-3b7de45061b4/artifacts/6mh0t1ie_ChatGPT%20Image%20Aug%2014%2C%202026%2C%2012_57_09%20PM.png";

export const IMAGES = {
  heroFluid:
    "https://images.unsplash.com/photo-1676594037920-a12bab344687?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHx0ZWFsJTIwbWFnZW50YSUyMGFic3RyYWN0JTIwM2QlMjBmbHVpZCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg0ODkyNDUzfDA&ixlib=rb-4.1.0&q=85",
  dashboard:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBmdXR1cmlzdGljJTIwc29mdHdhcmUlMjBkYXNoYm9hcmQlMjBkYXJrfGVufDB8fHx8MTc4NjAzMzE2NXww&ixlib=rb-4.1.0&q=85",
  control:
    "https://images.unsplash.com/photo-1720962158937-7ea890052166?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBmdXR1cmlzdGljJTIwc29mdHdhcmUlMjBkYXNoYm9hcmQlMjBkYXJrfGVufDB8fHx8MTc4NjAzMzE2NXww&ixlib=rb-4.1.0&q=85",
  studio:
    "https://images.unsplash.com/photo-1735948055457-8d816fb80a87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwdGVhbSUyMG9mZmljZSUyMGRhcmslMjBtb29keXxlbnwwfHx8fDE3ODQ2MTQ3MTd8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    icon: Smartphone,
    title: "Mobile Apps",
    color: "#E0146B",
    description:
      "Native-feel iOS and Android apps built once, shipped everywhere. Beautiful, fast, and built for retention.",
    tags: ["React Native", "Flutter", "iOS", "Android"],
  },
  {
    icon: Code2,
    title: "Web Development",
    color: "#0096C7",
    description:
      "High-performance web apps and platforms — from marketing sites that convert to complex SaaS products engineered to scale.",
    tags: ["React", "Next.js", "FastAPI", "Node.js"],
  },
  {
    icon: BrainCircuit,
    title: "AI & Automation",
    color: "#7C3AED",
    description:
      "Applied AI that ships — chat assistants, intelligent automation, and ML features woven into real products.",
    tags: ["LLMs", "RAG", "Automation", "ML Ops"],
  },
  {
    icon: Cloud,
    title: "Cloud Solutions",
    color: "#2563EB",
    description:
      "Cloud-native architecture, DevOps pipelines and infrastructure that stays up when your traffic spikes.",
    tags: ["AWS", "GCP", "Kubernetes", "CI/CD"],
  },
  {
    icon: PenTool,
    title: "UI/UX Design",
    color: "#FF8A00",
    description:
      "Interfaces people love to use. Research, UX flows and award-level visual design under one roof.",
    tags: ["UX Research", "UI Design", "Prototyping"],
  },
  {
    icon: ShieldCheck,
    title: "Digital Solutions",
    color: "#0D9488",
    description:
      "Beyond launch — digital strategy, monitoring, hardening and iteration so your product keeps compounding.",
    tags: ["Strategy", "SLA Support", "Analytics"],
  },
];

export const PROJECTS = [
  {
    name: "PropertyARV",
    category: "Proptech · SaaS Software",
    year: "2026",
    color: "#2563EB",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_014d8a17-6ce0-44ff-9bcf-3b7de45061b4/artifacts/u037k6d4_image.webp",
    monogram: "P",
    description:
      "Analyze properties in seconds — instant ARV, comps and deal scores for real-estate investors.",
  },
  {
    name: "SkriptRush",
    category: "SaaS · Web App",
    year: "2026",
    color: "#E0146B",
    image: "/projects/skriptrush.webp",
    monogram: "S",
    description:
      "Create and publish videos — from script to published content in one fast flow.",
  },
  {
    name: "SouqStream",
    category: "Mobile & Web App",
    year: "2026",
    color: "#0D9488",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_014d8a17-6ce0-44ff-9bcf-3b7de45061b4/artifacts/c8grs2f1_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2001_36_41%20PM.png",
    monogram: "Sq",
    description:
      "A live marketplace for Muslims — live-streamed shopping for halal products.",
  },
  {
    name: "Palace Of Flavor",
    category: "Catering · Website",
    year: "2026",
    color: "#FF8A00",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_014d8a17-6ce0-44ff-9bcf-3b7de45061b4/artifacts/dsubi0x6_image.webp",
    monogram: "P",
    description:
      "A website for Indian-Pakistani cuisine — menus, catering bookings and events.",
  },
];

export const PROCESS = [
  { step: "01", title: "Discover", color: "#E0146B", text: "We dig into your goals, users and constraints before a single pixel." },
  { step: "02", title: "Design", color: "#0096C7", text: "Flows, prototypes and a visual language that makes the product unmistakable." },
  { step: "03", title: "Build", color: "#FF8A00", text: "Weekly shippable increments — you see progress, not promises." },
  { step: "04", title: "Launch", color: "#7C3AED", text: "Battle-tested releases with monitoring, rollback plans and zero drama." },
  { step: "05", title: "Scale", color: "#0D9488", text: "We stay on board to iterate, optimize and grow what we shipped together." },
];

export const STATS = [
  { value: "40+", label: "Products shipped", color: "#E0146B" },
  { value: "12", label: "Industries served", color: "#0096C7" },
  { value: "99.9%", label: "Uptime average", color: "#FF8A00" },
  { value: "24/7", label: "Human support", color: "#7C3AED" },
];
